import * as React from 'react';
import {useHistory} from 'src/rerouter/index';
import {duotoneIconStyle} from 'src/utils/app-shell';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {getSettingsTabs} from 'src/utils/referrer-portal';
import {
  PageTitle,
  TabSlot,
  TabList,
  Tab,
  PageName,
  TitleMedium,
  Icon,
} from '@spaced-out/ui-design-system/lib/components/index';
import css from './settings.css';


const Settings = ({children}: {children: React.ReactNode}) => {
  const router = useHistory();
  const {t} = useLabelTranslation();
  const SETTINGS_TABS = getSettingsTabs(t);

  const defaultSelectedTab = SETTINGS_TABS.find((settingsTab) =>
    router.location.pathname.includes(settingsTab.tabId),
  );

  return (
    <>
      <PageTitle>
        <PageName>
          <TitleMedium>{t('Settings', 'Settings')}</TitleMedium>
          <Icon type="duotone" name="gear" style={duotoneIconStyle} />
        </PageName>
        <TabSlot className={css.tabSlot}>
          <TabList
            onSelect={(tab) => router.replace(tab.tabId)}
            size="medium"
            selectedTab={defaultSelectedTab}
          >
            {SETTINGS_TABS.map((tab) => (
              <Tab
                size="medium"
                key={tab.tabId}
                label={tab.label}
                tabId={tab.tabId}
              />
            ))}
          </TabList>
        </TabSlot>
      </PageTitle>
      <div className={css.children}>{children}</div>
    </>
  );
};

export default Settings;
